import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Owner contact — displayed publicly. Owner can update in .env-like frontend
// config OR by editing this file. Keeping this here so the site works even
// when admin is offline / DB unreachable for the public marketing site.
export const OWNER_CONTACT = {
  displayName: "VacayStay Rentals",
  email: "hello@vacaystayrentals.com",
  phone: "+1 (555) 010-1234",
  whatsapp: "15550101234", // digits only for wa.me link
  instagram: "vacaystayrentals",
};

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vs_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const waLink = (msg = "") =>
  `https://wa.me/${OWNER_CONTACT.whatsapp}?text=${encodeURIComponent(msg)}`;
export const telLink = () => `tel:+${OWNER_CONTACT.whatsapp}`;
export const mailLink = (subject = "", body = "") =>
  `mailto:${OWNER_CONTACT.email}?subject=${encodeURIComponent(
    subject,
  )}&body=${encodeURIComponent(body)}`;
